import React from 'react';
import { DefaultTheme, ThemeProvider } from 'styled-components';
import { MaltyThemeProviderProps } from './MaltyThemeProvider.types';
import { globalTheme } from './theme';
import { TypographyProvider } from './TypographyProvider';

export const MaltyThemeProvider = ({
  theme = 'global',
  children
}: MaltyThemeProviderProps) => {
  let selectedTheme: DefaultTheme;
  switch (theme) {
    default:
      selectedTheme = globalTheme;
      break;
  }

  return (
    <ThemeProvider theme={selectedTheme}>
      <TypographyProvider />
      {children}
    </ThemeProvider>
  );
};
